(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('action-ap-call-event', actionFunc);

    function actionFunc($q, lodash, $rootScope) {
        return function (panel, options, actionData, eventData) {
            return $q.when(run());

            function run() {
                const scope = panel.getPanelScope();
                if (lodash.has(options, 'conditions')) {
                    const panelData = {
                        panel,
                        actionData,
                        eventData
                    };
                    const result = options.conditions.reduce(function (result, condition) {
                        if (result === false) return result;
                        const keyPath = lodash.get(condition, 'path', '');
                        let value = '';
                        if (lodash.has(condition, 'valuePath')) {
                            value = lodash.get(panelData, condition.valuePath, false);
                        } else {
                            value = lodash.get(condition, 'value', false);
                        }

                        return lodash.get(panelData, keyPath, false) === value;
                    }, true);

                    if (!result) return result;
                }
                $rootScope.$broadcast(lodash.get(options, 'event', ''), {
                    actionData, eventData
                });
                return true;
            }
        };
    }
})();